import React, { useState, useEffect } from 'react';
import { Page, Navbar, Row, Col, List, ListItem, Icon, Toolbar, Button, Block } from "framework7-react";
import axios from 'axios';
import { API_BASE_URL, API_AUTH } from './../globals';
const OrderDetailPage = () => {
  const [data, setData] = useState([]);  
  useEffect(() => {
    axios.get(API_BASE_URL + 'restorder', {
        headers: {
          'Authorization': 'Basic ' + API_AUTH
        },
        params: {
          id: 1,
          limits: 1
        }
      })
      .then(response => { setData(response.data);} )
      .catch(error => console.log(error));
  }, []);

  return (
    <Page className="no-scroll bg-white" >
      <Navbar title="Order Details" noShadow backLink="Back"/>
      {data.length ? (
            data.map(order => (
            <Block className="m-0 p-0">
              <Row className="mt-0 p-3 pb-0 pt-2 bg-light">
                <Col width="15"><img
                        alt=""
                        slot="media"
                        src="https://cdn.framework7.io/placeholder/people-160x160-1.jpg"
                        width="40"
                        className="rounded-circle"
                    /></Col>
                <Col>{order.customer[0].cust_fname}<br/><small>Today at 12:30 pm</small></Col>
                <Col><p className="text-end">Order ID: <b>{order.token}</b><br/><small>Total: <b>$ {order.total}</b></small></p></Col>
              </Row>
              <List className="mt-0 mb-0 text-3">
                <ListItem link="#" title="+1 234 456 7890" after="Call">
                  <Icon slot="media" material="call"></Icon>
                </ListItem>
                <ListItem link="#" title={order.customer[0].cust_email} after="Email">
                  <Icon slot="media" material="email"></Icon>
                </ListItem>
                <ListItem link="#" title={order.customer[0].cust_add_lin_1} after="Navigate">
                  <Icon slot="media" material="map"></Icon>
                </ListItem>
                <ListItem>
                  <p><b>Message</b> {order.content}</p>
                </ListItem>
              </List>
              <Block className="m-0">
                <Row className="pt-2 pb-2 border-bottom bg-light">
                  <Col><b>Items</b></Col>
                  <Col className="text-center"><b>Quantity</b></Col>
                  <Col className="text-end"><b>Price</b></Col>
                </Row>
                {order.item.map(items => (
                  <Row className="pt-2 pb-2">
                    <Col>{items.menu_item_name}</Col>
                    <Col className="text-center">Tray: 1</Col>
                    <Col className="text-end">$ {items.menu_item_price}</Col>
                  </Row>
                ))}
              </Block>
              <Block className="m-0 pt-2 mb-5">  
                <Row>
                  <Col className="border-bottom px-3 pb-2 pt-2 bg-light"><b>Party Details</b></Col>
                </Row>
                <Row className="mt-2 text-2 px-1">
                  <Col width={50}><b>Party Name:</b> {order.party[0].party_name}</Col>
                  <Col><b>Party Size:</b> {order.party[0].party_size}</Col>
                </Row>
                <Row className="mt-2 text-2 px-1">
                  <Col width={50}><b>Date:</b> 19 - 04 - 2023</Col>
                  <Col><b>Confirm Date:</b> 19 - 05 - 2023</Col>
                </Row>
                <Row className="mt-2 text-2 px-1">
                  <Col><b>Address:</b> 333, Sweeterwater, Springs Bid, Spring Valley, CA</Col>              
                </Row>
                <Row className="mt-2 text-2 px-1">
                  <Col><b>Message:</b> Hi, we need extra large packing, Delivery person need to come our location, Hi, we need extra large packing, Delivery person need to come our location , Hi, we need extra large packing, Delivery person need to come our location</Col>              
                </Row>
              </Block>              
            </Block>
              ))
              ) : (
              <p>Error</p>
            )}
      <Toolbar tabbar noShadow bottom className='toolbar-cart'>
        <Block className='block-cart'>
          <Row>
            <Col width="50" medium="25">
              <Button fill large color="red" className='mt-1'> Cancel Order </Button>
            </Col>
            <Col width="50" medium="25">
              <Button fill large className='mt-1'> Accept Order </Button>
            </Col>
          </Row>          
        </Block>        
      </Toolbar>
    </Page>
  );
};

export default OrderDetailPage;